import { constants } from "../constants/redux-constants";

const initialState = {
  usagePayload: null,
  loading: false,
  error: null,
  isExpired: false,
};

export const planUsageReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.PLANS_USAGE.FETCH_USAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case constants.PLANS_USAGE.FETCH_USAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        usagePayload: action.payload,
        isExpired: action.payload?.errorCode === "subscription.expired",
      };
    case constants.PLANS_USAGE.FETCH_USAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
